module.exports = __webpack_public_path__ + "static/mike-652a03e1f99645865f2e00bd3f1ab4b0.jpg";